// extracted by mini-css-extract-plugin
export var active = "_7v-d";
export var blink = "_7v-e";
export var container = "_7v-5";
export var controls = "_7v-0";
export var controlsRight = "_7v-1";
export var fakeCursor = "_7v-c";
export var hidden = "_7v-b";
export var quillContainerSmall = "_7v-7";
export var quillEditor = "_7v-6";
export var quillEditorSmall = "_7v-8";
export var quillFormatButtons = "_7v-a";
export var quillToolbar = "_7v-9";
export var removePadding = "_7v-2";
export var state = "_7v-3";
export var stateTitle = "_7v-4";